import { createContext, useContext } from 'react'
import type { TranscriptEntry } from '@highlight/common'
import type { TranscriptMessage } from '@renderer/windows/features/side-panel/types'

/** A transcript turn as the views render it: the shared model plus view-only live state. */
export type Message = TranscriptMessage & {
  /** In-flight speech streamed onto the end of the turn (see `placeLivePartial`). */
  pendingText?: string
}

export interface AudioNoteRenameContext {
  audioNoteId: string
  transcriptEntries: Array<TranscriptEntry>
  onEntriesChanged: (entries: Array<TranscriptEntry>) => void
}

const AudioNoteCtx = createContext<AudioNoteRenameContext | null>(null)
export const AudioNoteRenameProvider = AudioNoteCtx.Provider
export const useAudioNoteRenameContext = () => useContext(AudioNoteCtx)
